// faq-filtered.js
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faf').forEach(initFaqFiltered);
});

function initFaqFiltered(root) {
  const items = root.querySelectorAll('.faf__item');
  const productTiles = root.querySelectorAll('.faf__product-tile');
  const topicPills = root.querySelectorAll('.faf__topic-pill');
  const listEl = root.querySelector('.faf__list');
  const emptyEl = root.querySelector('.faf__empty');
  const groupIconEl = document.getElementById('faf-group-icon');
  const groupTitleEl = document.getElementById('faf-group-title');
  const questionsSuffix = root.dataset.questionsSuffix || 'questions';

  function applyFilter(type, value, iconOrLabelEl) {
    productTiles.forEach(t => t.classList.toggle('faf__product-tile--active', type === 'product' && t.dataset.filterValue === value));
    topicPills.forEach(p => p.classList.toggle('faf__topic-pill--active', type === 'topic' && p.dataset.filterValue === value));

    let visibleCount = 0;
    items.forEach(item => {
      const matches = type === 'product'
        ? item.dataset.product === value
        : item.dataset.topic === value;
      item.hidden = !matches;
      if (matches) visibleCount++;
    });

    if (groupTitleEl) groupTitleEl.textContent = `${value} ${questionsSuffix}`.trim();
    if (type === 'topic' && iconOrLabelEl) {
      const icon = iconOrLabelEl.querySelector('.faf__topic-icon')?.textContent;
      if (groupIconEl && icon) groupIconEl.textContent = icon;
    }

    if (listEl) listEl.hidden = visibleCount === 0;
    if (emptyEl) emptyEl.hidden = visibleCount > 0;
  }

  productTiles.forEach(tile => {
    tile.addEventListener('click', () => applyFilter('product', tile.dataset.filterValue, tile));
  });
  topicPills.forEach(pill => {
    pill.addEventListener('click', () => applyFilter('topic', pill.dataset.filterValue, pill));
  });

  // accordion
  items.forEach(item => {
    const btn = item.querySelector('.faf__item-question');
    const answer = item.querySelector('.faf__item-answer');
    const inner = item.querySelector('.faf__item-answer-inner');
    const toggle = item.querySelector('.faf__item-toggle');

    btn?.addEventListener('click', () => {
      const isOpen = item.classList.contains('faf__item--open');
      if (isOpen) {
        item.classList.remove('faf__item--open');
        answer.style.maxHeight = '0px';
        if (toggle) toggle.textContent = '+';
      } else {
        item.classList.add('faf__item--open');
        answer.style.maxHeight = inner.scrollHeight + 'px';
        if (toggle) toggle.textContent = '−';
      }
    });
  });

  // open the first FAQ of the default (first) topic by default, matching the reference
  const firstTopicPill = topicPills[0];
  if (firstTopicPill) {
    applyFilter('topic', firstTopicPill.dataset.filterValue, firstTopicPill);
    const firstVisible = root.querySelector('.faf__item:not([hidden])');
    firstVisible?.querySelector('.faf__item-question')?.click();
  }
}
